import styled from 'styled-components';
import {JackpotAmountPreviewDefaultBox} from './jackpot-amount-preview.default.box';

export const JackpotAmountPreviewCasinoSIBox = styled(JackpotAmountPreviewDefaultBox)`
    padding: 0 0.5rem;
`;
